import type { InvestmentSummaryWithRequiredUuid } from "$root/pages/PortfolioDetails/common";
import type { AsOfSnapshotState } from "$root/pages/PortfolioDetails/as-of/useAsOfSnapshot";
import { createContext } from "react";

type PortfolioContextProps = {
	portfolio: InvestmentSummaryWithRequiredUuid;
	enhanced: boolean;
	/** Validated as-of date (`YYYY-MM-DD`): the page is pinned to a past snapshot. Only PortfolioDetails supplies it. */
	asOf?: string;
	/**
	 * Whether that snapshot can be read yet (MDOT-24860). Widgets must not issue their as-of reads
	 * until this is `ready` — the backend answers 404, not empty, for a snapshot it is still
	 * computing. Absent means the same as `live`.
	 */
	asOfSnapshot?: AsOfSnapshotState;
	selectedBenchmark: string | null;
	currentTab?: number;
	workspaceUid?: string;
	requestEnhance?: () => void;
	onChangePortfolioUid?: (uuid: string) => void;
};

export const PortfolioContext = createContext<PortfolioContextProps>(
	{} as PortfolioContextProps /* TODO: cheating avoid ts lint */,
);
